import { getHttpClient } from '../core/httpClient';
import type { Event, ListEventsOptions, AvailabilityResponse } from '../types';

export class EventsService {
  async list(options: ListEventsOptions = {}): Promise<Event[]> {
    const client = getHttpClient();
    return client.get<Event[]>('/public/events', {
      params: {
        limit: options.limit,
        cursor: options.cursor,
        startDate: options.startDate,
        endDate: options.endDate,
      },
    });
  }

  async get(eventId: string): Promise<Event> {
    const client = getHttpClient();
    return client.get<Event>(`/public/events/${eventId}`);
  }

  async getAvailability(eventId: string, date: string, time?: string): Promise<AvailabilityResponse> {
    const client = getHttpClient();
    return client.get<AvailabilityResponse>(`/public/events/${eventId}/availability`, {
      params: { date, time },
    });
  }
}

export const eventsService = new EventsService();

